import { useCallback, useMemo, useState } from 'react';

import { TokenizedCards } from './TokenizedCards';

import { Button, Dropdown } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import { SelectValue } from '@/types';
import { CardKey, formatNumberToLocale } from '@/utils';

interface Props {
  handleContinue: () => void;
  selectedCard: CardKey;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PayInInstallments = ({ handleContinue, selectedCard }: Props) => {
  const { pinsData, updatePinsData } = usePinsAccount();
  const { isDesktop } = useIsDesktop();
  const [isDropdownOpen, setIsDropdown] = useState(false);

  const installments = useMemo(() => {
    return pinsData.selectedProduct?.tipoProductoCuotaPrecioTO ?? [];
  }, [pinsData.selectedProduct?.tipoProductoCuotaPrecioTO]);

  const findByQuantity = useCallback(
    (quantity: number) => {
      return installments.findIndex(
        (installment) => installment.cantidadCuotas === quantity
      );
    },
    [installments]
  );

  const options: SelectValue[] = useMemo(() => {
    return installments.map((item) => ({
      value: item.cantidadCuotas,
      label: `${item.cantidadCuotas} ${
        item.cantidadCuotas === 1 ? 'cuota' : 'cuotas'
      } de $${formatNumberToLocale(item.precioCuota)}`,
    }));
  }, [installments]);

  const selectedInstallment = useMemo(() => {
    const index = findByQuantity(pinsData.selectedInstallment?.quantity ?? 0);
    return index > 0 ? index : 0;
  }, [findByQuantity, pinsData.selectedInstallment?.quantity]);

  return (
    <div
      className={`flex flex-col space-y-4 ${
        !pinsData.responseTokenizedCards &&
        (isDropdownOpen ? 'max-md:h-[450px]' : 'max-md:h-[240px]')
      }`}
    >
      <p className="text-center">
        Recordá que la operación puede demorar hasta 30 minutos en reflejarse
      </p>
      {/* TOKENIZADAS */}
      <TokenizedCards key={selectedCard} selectedCard={selectedCard} />
      <Dropdown
        className="font-semibold"
        label="Elegí el número de cuotas"
        options={options}
        selected={options[selectedInstallment]}
        withFloat={isDesktop}
        onChange={(item) => {
          updatePinsData({
            selectedInstallment: {
              quantity: item.value,
              totalAmount: installments[findByQuantity(item.value)].montoTotal,
            },
          });
        }}
        onOpenStateChange={(isOpen) => setIsDropdown(isOpen)}
      />
      <div className="flex justify-between text-gdt-blue bg-gdt-blue-xl2 p-3 rounded-lg font-bold">
        <span>Total a pagar </span>
        <span>
          {installments[selectedInstallment]?.montoTotal &&
            `$${formatNumberToLocale(
              installments[selectedInstallment]?.montoTotal
            )}`}
        </span>
      </div>
      <Button type="button" variant="primary" onClick={handleContinue}>
        Confirmar
      </Button>
    </div>
  );
};
